import { Link } from "react-router-dom";
import { PORTFOLIO_URL, DATA_SOURCE_URL } from "../global";
import "./Footer.css";

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="pa-footer">
      <div className="container pa-footer__inner">
        <div className="pa-footer__left">
          <nav className="pa-footer__nav" aria-label="Liens du pied de page">
            <Link to="/purpose">À propos</Link>
            <Link to="/mentions-legales">Mentions légales</Link>
            <Link to="/confidentialite">Confidentialité</Link>
            <a href={DATA_SOURCE_URL} rel="noopener noreferrer" target="_blank">
              Données : Paris Data
              <i className="ms-1 bi bi-box-arrow-up-right" aria-hidden="true"></i>
            </a>
          </nav>
          <p className="pa-footer__legal">
            &copy; {currentYear} Paris Agenda — édité par{" "}
            <a href={PORTFOLIO_URL} rel="noopener noreferrer" target="_blank">
              Yanis Arenes
            </a>
            . Projet indépendant, non affilié à la Ville de Paris. Données sous
            licence ODbL.
          </p>
        </div>

        <p className="pa-footer__sig">Paris, tous les jours.</p>
      </div>
    </footer>
  );
}

export default Footer;
